// extracted by mini-css-extract-plugin
export default {"table":"components-market-snapshots-table-module__table"};